import styled, { css } from 'styled-components';
import { media, layout } from '@prisjakt/ui-base';

type PropertyListProps = {
  verticallyCentered?: boolean;
};

export const Header = styled.div<PropertyListProps>`
  display: flex;
  flex: 1 1 0px;
  flex-direction: row;
  margin: ${layout.measurements.spacingTiny} 0;
  width: 100%;
  min-height: 0;
  align-items: baseline;
  ${props =>
    props.verticallyCentered &&
    css`
      align-items: center;
    `}
  ${media.mediumUp`
    padding-top: ${layout.measurements.spacingSmall};
    padding-left: ${layout.measurements.spacingTiny};
    padding-right: ${layout.measurements.spacingTiny};
  `};
`;

export const Media = styled.div`
  margin-right: ${layout.measurements.spacingTiny};
  margin-left: ${layout.measurements.spacingTiny};
  vertical-align: middle;
  ${media.smallOnly`
    margin-left: 0;
    margin-right: 0;
    margin-bottom: 0;
    
  `};
`;

export const Content = styled.div`
  padding-left: ${layout.measurements.spacingSmall};
  padding-right: ${layout.measurements.spacingSmall};
  display: flex;
  flex-direction: column;
  ${media.smallOnly`
    padding-left: ${layout.measurements.spacingSmall};
    padding-right: ${layout.measurements.spacingSmall};
  `};
`;

export const Title = styled.span`
  font-size: ${layout.measurements.fontSizeMega};
  line-height: 1.4;
  ${media.mediumUp`
    font-size: ${layout.measurements.fontSizeMedium};
    `};
`;

export const TitleWrapper = styled.span`
  ${media.smallOnly`
    font-size: ${layout.measurements.fontSizeSmall};
 `};
  font-size: ${layout.measurements.fontSizeNormal};
  font-weight: normal;
  margin-bottom: 0px;
  a {
    font-size: ${layout.measurements.fontSizeTiny};
    font-weight: normal;
    white-space: nowrap;
    color: ${p => p.theme.colors.base600};
    border-left: 1px solid ${p => p.theme.colors.base200};
    padding-left: ${layout.measurements.spacingSmall};
    margin-left: ${layout.measurements.spacingSmall};
    svg {
      vertical-align: middle;
    }
  }
`;
